import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { AbodOutlierConfig } from './abodOutlierConfig';
import { AdaptConfig } from './adaptConfig';
import { AggregateConfig } from './aggregateConfig';
import { AggregateV2Config } from './aggregateV2Config';
import { AmortizationConfig } from './amortizationConfig';
import { ArimaForecastConfig } from './arimaForecastConfig';
import { AssignmentOptimizationConfig } from './assignmentOptimizationConfig';
import { AutoRegressiveForecastConfig } from './autoRegressiveForecastConfig';
import { BinningConfig } from './binningConfig';
import { BoWTextClassifierConfig } from './boWTextClassifierConfig';
import { CaseConfig } from './caseConfig';
import { CatBoostClassifierConfig } from './catBoostClassifierConfig';
import { CatBoostRegressorConfig } from './catBoostRegressorConfig';
import { CategoryCalcConfig } from './categoryCalcConfig';
import { CategoryEncoderConfig } from './categoryEncoderConfig';
import { CblofOutlierConfig } from './cblofOutlierConfig';
import { ChangeCaseConfig } from './changeCaseConfig';
import { ChangeTypeConfig } from './changeTypeConfig';
import { ClassifierConfig } from './classifierConfig';
import { CleanCharacterConfig } from './cleanCharacterConfig';
import { CloudConfig } from './cloudConfig';
import { CnnTextClassifierConfig } from './cnnTextClassifierConfig';
import { CofOutlierConfig } from './cofOutlierConfig';
import { CombinationMatcherConfig } from './combinationMatcherConfig';
import { ConditionalConfig } from './conditionalConfig';
import { ConfusionMatrixConfig } from './confusionMatrixConfig';
import { DateAddConfig } from './dateAddConfig';
import { DateAggregateConfig } from './dateAggregateConfig';
import { DateDiffConfig } from './dateDiffConfig';
import { DateFormatConfig } from './dateFormatConfig';
import { DatePartConfig } from './datePartConfig';
import { DecisionTreeRegressorConfig } from './decisionTreeRegressorConfig';
import { DecisionTreeTrainConfig } from './decisionTreeTrainConfig';
import { DemandForecastConfig } from './demandForecastConfig';
import { DistinctConfig } from './distinctConfig';
import { DropConfig } from './dropConfig';
import { EnsembleTextClassifierConfig } from './ensembleTextClassifierConfig';
import { ExpSmoothingForecastConfig } from './expSmoothingForecastConfig';
import { ExpandPicklistConfig } from './expandPicklistConfig';
import { ExportConfig } from './exportConfig';
import { ExtractConfig } from './extractConfig';
import { FileConfig } from './fileConfig';
import { FillConfig } from './fillConfig';
import { FilterConfig } from './filterConfig';
import { ForecastConfig } from './forecastConfig';
import { FormulaConfig } from './formulaConfig';
import { FuzzyMatcherConfig } from './fuzzyMatcherConfig';
import { GbtRegressorConfig } from './gbtRegressorConfig';
import { GbtTrainConfig } from './gbtTrainConfig';
import { HbosOutlierConfig } from './hbosOutlierConfig';
import { HierarchyConfig } from './hierarchyConfig';
import { HierarchyV2Config } from './hierarchyV2Config';
import { HierarchyValidatorConfig } from './hierarchyValidatorConfig';
import { HierarchyValidatorV2Config } from './hierarchyValidatorV2Config';
import { IncentivesExportConfig } from './incentivesExportConfig';
import { IncentivesImportConfig } from './incentivesImportConfig';
import { IncentivesPeriodConfig } from './incentivesPeriodConfig';
import { IncentivesTableConfig } from './incentivesTableConfig';
import { IqrOutlierConfig } from './iqrOutlierConfig';
import { IsolationForestOutlierConfig } from './isolationForestOutlierConfig';
import { JoinConfig } from './joinConfig';
import { JoinV2Config } from './joinV2Config';
import { KNeighborsClassifierConfig } from './kNeighborsClassifierConfig';
import { KNeighborsOutlierConfig } from './kNeighborsOutlierConfig';
import { KNeighborsRegressorConfig } from './kNeighborsRegressorConfig';
import { LagConfig } from './lagConfig';
import { LgbmClassifierConfig } from './lgbmClassifierConfig';
import { LgbmRegressorConfig } from './lgbmRegressorConfig';
import { LimitConfig } from './limitConfig';
import { LinearRegressionForecastConfig } from './linearRegressionForecastConfig';
import { LinearRegressionTrainConfig } from './linearRegressionTrainConfig';
import { LogisticRegressionTrainConfig } from './logisticRegressionTrainConfig';
import { LookupConfig } from './lookupConfig';
import { MergeColumnsConfig } from './mergeColumnsConfig';
import { MinMaxScalerConfig } from './minMaxScalerConfig';
import { MlpRegressorConfig } from './mlpRegressorConfig';
import { MonteCarloConfig } from './monteCarloConfig';
import { MostCommonConfig } from './mostCommonConfig';
import { MovingAverageForecastConfig } from './movingAverageForecastConfig';
import { MultiFormulaConfig } from './multiFormulaConfig';
import { MultiObjectiveGaalOutlierConfig } from './multiObjectiveGaalOutlierConfig';
import { MultiPortPipeConfig } from './multiPortPipeConfig';
import { MultiReplaceConfig } from './multiReplaceConfig';
import { MultiUnionConfig } from './multiUnionConfig';
import { NaiveBayesTrainConfig } from './naiveBayesTrainConfig';
import { OneClassSvmOutlierConfig } from './oneClassSvmOutlierConfig';
import { OneHotEncoderConfig } from './oneHotEncoderConfig';
import { OutlierConfig } from './outlierConfig';
import { OversampleConfig } from './oversampleConfig';
import { PcaOutlierConfig } from './pcaOutlierConfig';
import { PeriodMapperConfig } from './periodMapperConfig';
import { PipeConfig } from './pipeConfig';
import { PredictGenderConfig } from './predictGenderConfig';
import { PredictorConfig } from './predictorConfig';
import { ProphetForecastConfig } from './prophetForecastConfig';
import { QuantileConfig } from './quantileConfig';
import { RandomForestRegressorConfig } from './randomForestRegressorConfig';
import { RandomForestTrainConfig } from './randomForestTrainConfig';
import { RandomNumberGeneratorConfig } from './randomNumberGeneratorConfig';
import { RankConfig } from './rankConfig';
import { RecordIdConfig } from './recordIdConfig';
import { RegressorConfig } from './regressorConfig';
import { RemoveEmptyConfig } from './removeEmptyConfig';
import { RemoveOutliersConfig } from './removeOutliersConfig';
import { RenameConfig } from './renameConfig';
import { ReorderConfig } from './reorderConfig';
import { RepeatConfig } from './repeatConfig';
import { ReplaceConfig } from './replaceConfig';
import { ReshapeConfig } from './reshapeConfig';
import { ReusableLogicConfig } from './reusableLogicConfig';
import { ReusableLogicInputConfig } from './reusableLogicInputConfig';
import { ReusableLogicOutputConfig } from './reusableLogicOutputConfig';
import { RuleMapperConfig } from './ruleMapperConfig';
import { RuleMapperV2Config } from './ruleMapperV2Config';
import { RunningAverageConfig } from './runningAverageConfig';
import { RunningTotalConfig } from './runningTotalConfig';
import { SampleConfig } from './sampleConfig';
import { SampleCustomersConfig } from './sampleCustomersConfig';
import { SeasonalArimaForecastConfig } from './seasonalArimaForecastConfig';
import { SegmentationConfig } from './segmentationConfig';
import { SelectConfig } from './selectConfig';
import { SelectWordConfig } from './selectWordConfig';
import { SimpleExpSmoothingForecastConfig } from './simpleExpSmoothingForecastConfig';
import { SingleObjectiveGaalOutlierConfig } from './singleObjectiveGaalOutlierConfig';
import { SmartMatcherConfig } from './smartMatcherConfig';
import { SnapshotConfig } from './snapshotConfig';
import { SortCalcConfig } from './sortCalcConfig';
import { SortConfig } from './sortConfig';
import { SplitConfig } from './splitConfig';
import { StandardScalerConfig } from './standardScalerConfig';
import { SubspaceOutlierConfig } from './subspaceOutlierConfig';
import { SvmTrainConfig } from './svmTrainConfig';
import { TextBetweenConfig } from './textBetweenConfig';
import { TextClassifierConfig } from './textClassifierConfig';
import { TextGradeLevelConfig } from './textGradeLevelConfig';
import { TextLengthConfig } from './textLengthConfig';
import { TextPartConfig } from './textPartConfig';
import { TextSentimentConfig } from './textSentimentConfig';
import { TimeShiftCalcConfig } from './timeShiftCalcConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { TrimConfig } from './trimConfig';
import { TrimTagsConfig } from './trimTagsConfig';
import { TrueUpConfig } from './trueUpConfig';
import { UndersampleConfig } from './undersampleConfig';
import { UnionConfig } from './unionConfig';
import { USIncomeConfig } from './usIncomeConfig';
import { USPopulationConfig } from './usPopulationConfig';
import { UserDefinedCalcConfig } from './userDefinedCalcConfig';
import { VectorAutoRegressiveForecastConfig } from './vectorAutoRegressiveForecastConfig';
import { WeatherConfig } from './weatherConfig';
import { WeightedAverageConfig } from './weightedAverageConfig';
import { WeightedMovingAverageForecastConfig } from './weightedMovingAverageForecastConfig';
import { WordFrequencyConfig } from './wordFrequencyConfig';
import { XgbClassifierConfig } from './xgbClassifierConfig';
import { XgbRegressorConfig } from './xgbRegressorConfig';
import { ZScoreOutlierConfig } from './zScoreOutlierConfig';
import { PeriodAddConfig } from './periodAddConfig';
import { PeriodDiffConfig } from './periodDiffConfig';
import { PeriodAccumulationConfig } from './periodAccumulationConfig';
import { ReshapeV2Config } from './reshapeV2Config';
import { SplitColumnsConfig } from './splitColumnsConfig';
const ToolConfigByType = {
    [ToolType.ABOD_OUTLIER]: AbodOutlierConfig,
    [ToolType.ADAPT]: AdaptConfig,
    [ToolType.AGGREGATE]: AggregateConfig,
    [ToolType.AGGREGATEV2]: AggregateV2Config,
    [ToolType.AMORTIZATION]: AmortizationConfig,
    [ToolType.ARIMA_FORECAST]: ArimaForecastConfig,
    [ToolType.ASSIGNMENT_OPTIMIZATION]: AssignmentOptimizationConfig,
    [ToolType.AUTO_REGRESSIVE_FORECAST]: AutoRegressiveForecastConfig,
    [ToolType.BINNING]: BinningConfig,
    [ToolType.BOW_TEXT_CLASSIFIER]: BoWTextClassifierConfig,
    [ToolType.CASE]: CaseConfig,
    [ToolType.CAT_BOOST_CLASSIFIER]: CatBoostClassifierConfig,
    [ToolType.CAT_BOOST_REGRESSOR]: CatBoostRegressorConfig,
    [ToolType.CATEGORY_ENCODER]: CategoryEncoderConfig,
    [ToolType.CATEGORY_CALC]: CategoryCalcConfig,
    [ToolType.CBLOF_OUTLIER]: CblofOutlierConfig,
    [ToolType.CHANGE_CASE]: ChangeCaseConfig,
    [ToolType.CHANGE_TYPE]: ChangeTypeConfig,
    [ToolType.CLASSIFIER]: ClassifierConfig,
    [ToolType.CLEAN_CHARACTER]: CleanCharacterConfig,
    [ToolType.CLOUD]: CloudConfig,
    [ToolType.CNN_TEXT_CLASSIFIER]: CnnTextClassifierConfig,
    [ToolType.COF_OUTLIER]: CofOutlierConfig,
    [ToolType.COMBINATION_MATCHER]: CombinationMatcherConfig,
    [ToolType.CONDITIONAL]: ConditionalConfig,
    [ToolType.CONFUSION_MATRIX]: ConfusionMatrixConfig,
    [ToolType.DATE_ADD]: DateAddConfig,
    [ToolType.DATE_AGGREGATE]: DateAggregateConfig,
    [ToolType.DATE_DIFF]: DateDiffConfig,
    [ToolType.DATE_FORMAT]: DateFormatConfig,
    [ToolType.DATE_PART]: DatePartConfig,
    [ToolType.DECISION_TREE_REGRESSOR]: DecisionTreeRegressorConfig,
    [ToolType.DECISION_TREE_TRAIN]: DecisionTreeTrainConfig,
    [ToolType.DEMAND_FORECAST]: DemandForecastConfig,
    [ToolType.DISTINCT]: DistinctConfig,
    [ToolType.DROP]: DropConfig,
    [ToolType.ENSEMBLE_TEXT_CLASSIFIER]: EnsembleTextClassifierConfig,
    [ToolType.EXP_SMOOTHING_FORECAST]: ExpSmoothingForecastConfig,
    [ToolType.EXPAND_PICKLIST]: ExpandPicklistConfig,
    [ToolType.EXPORT]: ExportConfig,
    [ToolType.EXTRACT]: ExtractConfig,
    [ToolType.FILE]: FileConfig,
    [ToolType.FILL]: FillConfig,
    [ToolType.FILTER]: FilterConfig,
    [ToolType.FORECAST]: ForecastConfig,
    [ToolType.FORMULA]: FormulaConfig,
    [ToolType.FUZZY_MATCHER]: FuzzyMatcherConfig,
    [ToolType.GBT_REGRESSOR]: GbtRegressorConfig,
    [ToolType.GBT_TRAIN]: GbtTrainConfig,
    [ToolType.HBOS_OUTLIER]: HbosOutlierConfig,
    [ToolType.HIERARCHY]: HierarchyConfig,
    [ToolType.HIERARCHYV2]: HierarchyV2Config,
    [ToolType.HIERARCHY_VALIDATOR]: HierarchyValidatorConfig,
    [ToolType.HIERARCHY_VALIDATORV2]: HierarchyValidatorV2Config,
    [ToolType.INCENTIVES_EXPORT]: IncentivesExportConfig,
    [ToolType.INCENTIVES_IMPORT]: IncentivesImportConfig,
    [ToolType.INCENTIVES_TABLE]: IncentivesTableConfig,
    [ToolType.INCENTIVES_PERIOD]: IncentivesPeriodConfig,
    [ToolType.IQR_OUTLIER]: IqrOutlierConfig,
    [ToolType.ISOLATION_FOREST_OUTLIER]: IsolationForestOutlierConfig,
    [ToolType.JOIN]: JoinConfig,
    [ToolType.JOINV2]: JoinV2Config,
    [ToolType.K_NEIGHBORS_CLASSIFIER]: KNeighborsClassifierConfig,
    [ToolType.K_NEIGHBORS_OUTLIER]: KNeighborsOutlierConfig,
    [ToolType.K_NEIGHBORS_REGRESSOR]: KNeighborsRegressorConfig,
    [ToolType.LAG]: LagConfig,
    [ToolType.LGBM_CLASSIFIER]: LgbmClassifierConfig,
    [ToolType.LGBM_REGRESSOR]: LgbmRegressorConfig,
    [ToolType.LIMIT]: LimitConfig,
    [ToolType.LINEAR_REGRESSION_FORECAST]: LinearRegressionForecastConfig,
    [ToolType.LINEAR_REGRESSION_TRAIN]: LinearRegressionTrainConfig,
    [ToolType.LOGISTIC_REGRESSION_TRAIN]: LogisticRegressionTrainConfig,
    [ToolType.LOOKUP]: LookupConfig,
    [ToolType.MERGE_COLUMNS]: MergeColumnsConfig,
    [ToolType.MIN_MAX_SCALER]: MinMaxScalerConfig,
    [ToolType.MLP_REGRESSOR]: MlpRegressorConfig,
    [ToolType.MONTE_CARLO]: MonteCarloConfig,
    [ToolType.MOST_COMMON]: MostCommonConfig,
    [ToolType.MOVING_AVERAGE_FORECAST]: MovingAverageForecastConfig,
    [ToolType.MULTI_FORMULA]: MultiFormulaConfig,
    [ToolType.MULTI_OBJECTIVE_GAAL_OUTLIER]: MultiObjectiveGaalOutlierConfig,
    [ToolType.MULTI_PORT_PIPE]: MultiPortPipeConfig,
    [ToolType.MULTI_UNION]: MultiUnionConfig,
    [ToolType.MULTI_REPLACE]: MultiReplaceConfig,
    [ToolType.NAIVE_BAYES_TRAIN]: NaiveBayesTrainConfig,
    [ToolType.ONE_CLASS_SVM_OUTLIER]: OneClassSvmOutlierConfig,
    [ToolType.ONE_HOT_ENCODER]: OneHotEncoderConfig,
    [ToolType.OUTLIER]: OutlierConfig,
    [ToolType.OVERSAMPLE]: OversampleConfig,
    [ToolType.PCA_OUTLIER]: PcaOutlierConfig,
    [ToolType.PERIOD_ACCUMULATION]: PeriodAccumulationConfig,
    [ToolType.PERIOD_ADD]: PeriodAddConfig,
    [ToolType.PERIOD_DIFF]: PeriodDiffConfig,
    [ToolType.PERIOD_MAPPER]: PeriodMapperConfig,
    [ToolType.PIPE]: PipeConfig,
    [ToolType.PREDICT_GENDER]: PredictGenderConfig,
    [ToolType.PREDICTOR]: PredictorConfig,
    [ToolType.PROPHET_FORECAST]: ProphetForecastConfig,
    [ToolType.QUANTILE]: QuantileConfig,
    [ToolType.RANDOM_NUMBER_GENERATOR]: RandomNumberGeneratorConfig,
    [ToolType.RANDOM_FOREST_REGRESSOR]: RandomForestRegressorConfig,
    [ToolType.RANDOM_FOREST_TRAIN]: RandomForestTrainConfig,
    [ToolType.RANK]: RankConfig,
    [ToolType.RECORD_ID]: RecordIdConfig,
    [ToolType.REGRESSOR]: RegressorConfig,
    [ToolType.REMOVE_EMPTY]: RemoveEmptyConfig,
    [ToolType.REMOVE_OUTLIERS]: RemoveOutliersConfig,
    [ToolType.RENAME]: RenameConfig,
    [ToolType.REORDER]: ReorderConfig,
    [ToolType.REPEAT]: RepeatConfig,
    [ToolType.REPLACE]: ReplaceConfig,
    [ToolType.RESHAPE]: ReshapeConfig,
    [ToolType.RESHAPEV2]: ReshapeV2Config,
    [ToolType.REUSABLE_LOGIC]: ReusableLogicConfig,
    [ToolType.REUSABLE_LOGIC_INPUT]: ReusableLogicInputConfig,
    [ToolType.REUSABLE_LOGIC_OUTPUT]: ReusableLogicOutputConfig,
    [ToolType.RULE_MAPPER]: RuleMapperConfig,
    [ToolType.RULE_MAPPERV2]: RuleMapperV2Config,
    [ToolType.RUNNING_AVERAGE]: RunningAverageConfig,
    [ToolType.RUNNING_TOTAL]: RunningTotalConfig,
    [ToolType.SAMPLE]: SampleConfig,
    [ToolType.SAMPLE_CUSTOMERS]: SampleCustomersConfig,
    [ToolType.SEASONAL_ARIMA_FORECAST]: SeasonalArimaForecastConfig,
    [ToolType.SEGMENTATION]: SegmentationConfig,
    [ToolType.SELECT]: SelectConfig,
    [ToolType.SELECT_WORD]: SelectWordConfig,
    [ToolType.SIMPLE_EXP_SMOOTHING_FORECAST]: SimpleExpSmoothingForecastConfig,
    [ToolType.SINGLE_OBJECTIVE_GAAL_OUTLIER]: SingleObjectiveGaalOutlierConfig,
    [ToolType.SMART_MATCHER]: SmartMatcherConfig,
    [ToolType.SNAPSHOT]: SnapshotConfig,
    [ToolType.SORT]: SortConfig,
    [ToolType.SORT_CALC]: SortCalcConfig,
    [ToolType.SPLIT]: SplitConfig,
    [ToolType.SPLIT_COLUMNS]: SplitColumnsConfig,
    [ToolType.STANDARD_SCALER]: StandardScalerConfig,
    [ToolType.SUBSPACE_OUTLIER]: SubspaceOutlierConfig,
    [ToolType.SVM_TRAIN]: SvmTrainConfig,
    [ToolType.TEXT_BETWEEN]: TextBetweenConfig,
    [ToolType.TEXT_CLASSIFIER]: TextClassifierConfig,
    [ToolType.TEXT_GRADE_LEVEL]: TextGradeLevelConfig,
    [ToolType.TEXT_LENGTH]: TextLengthConfig,
    [ToolType.TEXT_PART]: TextPartConfig,
    [ToolType.TEXT_SENTIMENT]: TextSentimentConfig,
    [ToolType.TIME_SHIFT_CALC]: TimeShiftCalcConfig,
    [ToolType.TRIM]: TrimConfig,
    [ToolType.TRIM_TAGS]: TrimTagsConfig,
    [ToolType.TRUE_UP]: TrueUpConfig,
    [ToolType.UNDERSAMPLE]: UndersampleConfig,
    [ToolType.UNION]: UnionConfig,
    [ToolType.USER_DEFINED_CALC]: UserDefinedCalcConfig,
    [ToolType.US_INCOME]: USIncomeConfig,
    [ToolType.US_POPULATION]: USPopulationConfig,
    [ToolType.VECTOR_AUTO_REGRESSIVE_FORECAST]: VectorAutoRegressiveForecastConfig,
    [ToolType.WEATHER]: WeatherConfig,
    [ToolType.WEIGHTED_AVERAGE]: WeightedAverageConfig,
    [ToolType.WEIGHTED_MOVING_AVERAGE_FORECAST]: WeightedMovingAverageForecastConfig,
    [ToolType.WORD_FREQUENCY]: WordFrequencyConfig,
    [ToolType.XGB_CLASSIFIER]: XgbClassifierConfig,
    [ToolType.XGB_REGRESSOR]: XgbRegressorConfig,
    [ToolType.Z_SCORE_OUTLIER]: ZScoreOutlierConfig
};
export const getToolConfig = (toolType) => {
    return ToolConfigByType[toolType];
};
export const getToolInfo = (toolType) => {
    const toolConfig = getToolConfig(toolType);
    if (!toolConfig) {
        console.log(`tooltype missing: ${toolType}`);
        console.log(ToolConfigByType);
    }
    return toolConfig ? toolConfig.info : new ToolConfigInfo('', [], [], [], [], false);
};
//# sourceMappingURL=toolConfigHelper.js.map